module.exports = __webpack_public_path__ + "static/img/s1.23988eaa.png";